import { Box } from '@mui/material';
import { FC } from 'react';
import { AuditLogDetailsDrawer } from './AuditLogDetailsDrawer/AuditLogDetailsDrawer';
import { AuditLogDrawer } from './AuditLogDrawer/AuditLogDrawer';

export const Drawer: FC = () => {
    return (
        <Box>
            <AuditLogDrawer />
            <AuditLogDetailsDrawer />
        </Box>
    );
};
